import {css} from '@emotion/react'
import {colors} from '../../../constants'

import StarRating from '../../../images/browser/star-rating.svg'

const text = {
    en: {
        headerText: `Reviews`,
        quoteCardsData: [
            {
                quote: `“Startpage contributes to making online privacy regulation possible by blinding our Internet searches and providing results based on our queries, not based on who/where we are and what our browsing history is.”`,
                name: `Laura Brandimarte`,
                professionalTitle: `MIS Professor of Social and Ethical Issues of the Internet`,
            },
            {
                quote: `“Be careful about what you share with large service providers… There are alternatives like Startpage…that don’t store that information.”`,
                name: `Edward Snowden`,
                professionalTitle: `President of Freedom of the Press Foundation`,
            },
            {
                quote: `“Startpage has supported NOYB’s work from the very beginning and thus allows us to effectively enforce European data protection law and to strengthen our backing for data protection-friendly alternatives.”`,
                name: `Max Schrems`,
                professionalTitle: `Founder of NOYB - European Center for Digital Rights`,
            },
        ],
    },
    de: {
        headerText: `Meinungen`,
        quoteCardsData: [
            {
                quote: `„Startpage macht echten Online-Datenschutz möglich, indem Internet-Suchanfragen anonymisiert werden und nur Ergebnisse angezeigt werden, die auf der aktuellen Suchanfrage basieren anstatt darauf, wer oder wo der Nutzende ist und was in der Vergangenheit gesucht wurde.“`,
                name: `Laura Brandimarte`,
                professionalTitle: `MIS-Professor für soziale und ethische Fragen des Internets`,
            },
            {
                quote: `„Seien Sie vorsichtig, was Sie mit großen Firmen teilen... Es gibt Alternativen wie Startpage..., die diese Informationen nicht speichern.“`,
                name: `Edward Snowden`,
                professionalTitle: `Präsident der Freedom of the Press Foundation`,
            },
            {
                quote: `„Startpage hat die Arbeit von NOYB von Anfang an unterstützt und hilft uns, das europäische Datenschutzrecht effektiv durchzusetzen und uns für datenschutzfreundliche Alternativen stark zu machen.“`,
                name: `Max Schrems`,
                professionalTitle: `Gründer von NOYB - Euopäisches Zentrum für digitale Rechte`,
            },
        ],
    },
    nl: {
        headerText: `Reviews`,
        quoteCardsData: [
            {
                quote: `"Startpage draagt bij aan het mogelijk maken van online privacy regelgeving door onze zoekopdrachten op het internet te maskeren en resultaten te leveren op basis van onze zoektermen, en niet op basis van wie/waar we zijn en wat onze surfgeschiedenis is."`,
                name: `Laura Brandimarte`,
                professionalTitle: `MIS-professor sociale en ethische kwesties van het internet`,
            },
            {
                quote: `"Wees voorzichtig met wat je deelt met grote dienstverleners... Er zijn alternatieven zoals Startpage... die die informatie niet opslaan."`,
                name: `Edward Snowden`,
                professionalTitle: `Voorzitter van de Freedom of the Press Foundation`,
            },
            {
                quote: `"Startpage heeft het werk van NOYB vanaf het begin ondersteund en stelt ons daarmee in staat de Europese wetgeving op het gebied van gegevensbescherming effectief te handhaven en onze steun voor gegevensbeschermingsvriendelijke alternatieven te versterken."`,
                name: `Max Schrems`,
                professionalTitle: `Oprichter van NOYB - Europees centrum voor digitale rechten`,
            },
        ],
    },
}

const ReviewsSection = ({overrideStyles, languageCode}) => {
    const {headerText, quoteCardsData} = text[languageCode]
    return (
        <section
            className="section-2"
            css={css`
                padding: 80px 2rem;
                ${overrideStyles};
            `}
        >
            <div
                className="content"
                css={css`
                    max-width: 966px;
                    margin: 0 auto;
                `}
            >
                <h2
                    css={css`
                        text-align: center;
                        font-size: 40px;
                        font-weight: 800;
                    `}
                >
                    {headerText}
                </h2>
                <div
                    className="star-rating-container"
                    css={css`
                        display: flex;
                        justify-content: center;
                        margin: 32px 0 0;
                    `}
                >
                    <StarRating />
                </div>
                <div
                    className="quote-cards"
                    css={css`
                        display: grid;
                        grid-gap: 32px;
                        grid-template-columns: 1fr 1fr 1fr;
                        margin: 32px 0 0;
                        @media (max-width: 900px) {
                            grid-template-columns: 1fr;
                        }
                    `}
                >
                    {quoteCardsData.map(({quote, name, professionalTitle}, i) => {
                        return (
                            <div
                                className="quote-card"
                                css={css`
                                    border-radius: 10px;
                                    box-shadow: 0px 20px 26px rgba(0, 0, 0, 0.1);
                                    padding: 24px;
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    p {
                                        line-height: 24px;
                                        font-size: 16px;
                                    }
                                `}
                                key={i}
                            >
                                <p
                                    className="quote"
                                    css={css`
                                        margin: 0 0 24px;
                                    `}
                                >
                                    {quote}
                                </p>
                                <div className="details">
                                    <p
                                        className="name"
                                        css={css`
                                            color: ${colors.brandBlue};
                                            font-weight: 600;
                                        `}
                                    >
                                        {name}
                                    </p>
                                    <p className="professional-title">{professionalTitle}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default ReviewsSection
